import React from "react";
import { connect } from "react-redux";
import { transporterJson } from "../../../DynamicFormsJson/MastersJSON/transporter";
import { getAllTransporterListByUserTypeUpdated } from "../../../Slice/transporter.slice";
import { transporterColumns } from "../../../tableColumns/table-columns";
import DynamicTabwiseTable from "../../../components/dynamicscreens/DynamicTabwiseTable";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import {
  deleteFailedMsg,
  deletemsg,
  deleteWarningMsg,
  noInternetMsg,
  serverMsg,
} from "../../../config/messageconstant";
import endpoint from "../../../config/endpoints";
import { downloadF } from "../../PDF/PDFDownload";
import { apiDelete } from "../../../utils/api_service";

class TransporterList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabValue: 1,
      moduleObjDataObj: {},
      isLog: true,
      dynamicMasterData: {
        TransporterListInActive: this.props.transporterList?.transporter.filter(
          (row) => row.isActive == 0
        ),
        TransporterListActive: this.props.transporterList?.transporter.filter(
          (row) => row.isActive == 1
        ),
      },
      tabList: [
        {
          label: "Active",
          allyProps: 0,
          columns: transporterColumns,
          showExcelDownload: true,
          changeExcelURL: "sales-executive-data",
          isActionColActive: true,
          value: "TransporterListActive",
        },
        {
          label: "InActive",
          allyProps: 1,
          columns: transporterColumns,
          showExcelDownload: true,
          changeExcelURL: "sales-executive-data",
          isActionColActive: true,
          value: "TransporterListInActive",
        },
      ],
    };
  }

  componentDidMount() {
    if (
      localStorage.getItem("showFilterDataWiseExcel") &&
      localStorage.getItem("showFilterDataWiseExcel") == 1
    ) {
      this.setState((prevState) => ({
        tabList: prevState.tabList.map((tab) => ({
          ...tab,
          showExcelDownload: false,
        })),
      }));
    }
    this.getListData();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.transporterList !== nextProps.transporterList) {
      if (
        this.props.transporterList?.transporter !==
        nextProps.transporterList?.transporter
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            TransporterListActive: nextProps.transporterList?.transporter
              .filter((row) => row.isActive == 1)
              .map((rowData, index) => {
                return { ...rowData, index: index + 1 };
              }),
            TransporterListInActive: nextProps.transporterList?.transporter
              .filter((row) => row.isActive == 0)
              .map((rowData, index) => {
                return { ...rowData, index: index + 1 };
              }),
          },
        });
      }
    }
  }

  getTabValue = (rowValue) => {
    this.setState({
      tabValue: rowValue == 0 ? 1 : 0,
    });
  };

  getListData = async () => {
    const {
      getAllTransporterListByUserTypeUpdated,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getAllTransporterListByUserTypeUpdated({}).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  generateStaticExcelMethod = () => {
    const { showLoador, showNotification } = this.props;
    showLoador({ loador: true });
    downloadF({
      url: endpoint.exportData + "/get-transporter-data",
      ext: "xls",
      openNewTab: true,
    }).then((response) => {
      showLoador({ loador: false });
      if (!response) {
        showNotification({
          msg: serverMsg,
          severity: "error",
        });
      }
    });
  };

  rowDelete = (rowData) => {
    const { showNotification, showLoador } = this.props;
    swal({
      title: "Are you sure?",
      text: deleteWarningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (rowData.id) {
          showLoador({ loador: true });
          apiDelete({
            url: endpoint.transporter + "/" + rowData.id,
          }).then(({ data, success }) => {
            showLoador({ loador: false });
            if (success) {
              if (data && data.data && data.data.statusCode == 200) {
                showNotification({ msg: deletemsg });
                window.location.reload();
              } else {
                showNotification({ msg: deleteFailedMsg, severity: "error" });
              }
            } else {
              showNotification({
                msg: serverMsg,
                severity: "error",
              });
            }
          });
        }
      }
    });
  };

  render() {
    const { transporterList } = this.props;
    const { dynamicMasterData, tabList } = this.state;
    return (
      <>
        <DynamicTabwiseTable
          dynamicMasterData={dynamicMasterData}
          formPath={transporterJson.formPath}
          screenTitle={transporterJson.screenTitle}
          fieldMeta={transporterJson.fieldMeta}
          showPdfDownload={transporterJson.showPdfDownload}
          showExcelDownload={true}
          isExcelStaticUrl={true}
          filterDataExcel={true}
          pdfFileName={transporterJson.pdfFileName}
          excelFileName={transporterJson.excelFileName}
          showAddButton={transporterJson.showAddButton}
          tableColumnsToFilter={transporterJson.tableColumnsToFilter}
          tableColumns={transporterColumns}
          tableData={transporterList?.transporter}
          apiBaseURL={transporterJson.apiBaseURL}
          callApi={false}
          isActiveURL={transporterJson.apiBaseURL + "/update-is-active"}
          showAddButtonInTable={false}
          searchButtonGrid={transporterJson.searchButtonGrid}
          getTableDataById={true}
          onSearchData={this.getListData}
          showApplyCredintial={false}
          rowStatusTrue={false}
          rowApply={this.onClickApplySend}
          tabList={tabList}
          generateStaticExcelMethod={this.generateStaticExcelMethod}
          getTableData={getAllTransporterListByUserTypeUpdated}
          isNote={true}
          isNoteValue={"Add Transporter Details"}
          rowList={dynamicMasterData}
          formPathStatic={false}
          showHeadEdit={true}
          staticEdit={false}
          deleteStaticTrue={true}
          getTabValue={this.getTabValue}
          showHeadDelete={true}
          showPegination={true}
          rowDelete={this.rowDelete}
          showView={true}
          formPathView={transporterJson.formPathView}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  transporterList: state.transporter,
});
const mapDispatchToProps = {
  getAllTransporterListByUserTypeUpdated,
  showLoador,
  showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(TransporterList);
